export default "__VITE_ASSET__WALk_DEp__"